<div class="full-page-container">
  <!-- Points Summary -->
  <div class="container">
    <fgb-points-summary-bar
      [backButtonLink]="marketplaceItemType.backLink"
      [marketplaceItemGroup]="marketplaceItemType.group"
    ></fgb-points-summary-bar>
  </div>

  <div class="container">
    <div
      class="back-btn text-primary cursor-pointer d-none d-lg-flex align-items-center justify-content-center"
      (click)="goBack()"
    >
      <span class="material-symbols-outlined ms-2 text-white"> arrow_back_ios </span>
    </div>
  </div>

  <fgbcl-marketplace-details [itemId]="id" [actionLabels]="actionLabels"></fgbcl-marketplace-details>
</div>
